export type Role = "company_user" | "company_admin" | "system_admin";

export type LegacyNavItem = {
  id: string;
  label: string;
  icon: string;
  path: string;
  roles: readonly Role[];
};

export const legacyNavItems: readonly LegacyNavItem[] = [
  { id: "dashboard", label: "首頁", icon: "BarChart3", path: "/", roles: ["company_user", "company_admin", "system_admin"] },
  { id: "purchase-orders", label: "訂貨單列表", icon: "ShoppingCart", path: "/purchase-orders", roles: ["company_user"] },
  { id: "shipments", label: "貨運列表", icon: "Truck", path: "/shipments", roles: ["company_user"] },
  { id: "payments", label: "付款列表", icon: "CreditCard", path: "/payments", roles: ["company_user"] },
  { id: "reports", label: "報表中心", icon: "BarChart3", path: "/reports", roles: ["company_user"] },
  { id: "master-data", label: "基礎資料", icon: "Database", path: "/master-data", roles: ["company_user"] },
  { id: "users", label: "用戶管理", icon: "Users", path: "/admin/users", roles: ["company_admin", "system_admin"] },
  { id: "companies", label: "公司管理", icon: "Building2", path: "/admin/companies", roles: ["system_admin"] },
  { id: "company-settings", label: "公司設定", icon: "Settings", path: "/admin/company-settings", roles: ["company_admin"] },
  { id: "system-settings", label: "全域系統配置", icon: "Settings", path: "/admin/system-settings", roles: ["system_admin"] },
  { id: "changelog", label: "更新日誌", icon: "FileText", path: "/changelog", roles: ["company_user", "company_admin", "system_admin"] },
];

function normalizedPath(path: string): string {
  const pathname = path.split(/[?#]/, 1)[0] || "/";
  return pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
}

function routeItemForPath(pathname: string): LegacyNavItem | null {
  if (pathname === "/") return legacyNavItems[0];
  const exact = legacyNavItems.find((candidate) => candidate.path !== "/" && pathname === candidate.path);
  if (exact) return exact;
  if (pathname === "/purchase-orders/add" || /^\/purchase-orders\/edit\/[^/]+$/.test(pathname)) {
    return legacyNavItems.find((candidate) => candidate.id === "purchase-orders") || null;
  }
  if (/^\/shipments\/edit\/[^/]+$/.test(pathname)) {
    return legacyNavItems.find((candidate) => candidate.id === "shipments") || null;
  }
  if (pathname === "/reports/direct-imports") {
    return legacyNavItems.find((candidate) => candidate.id === "reports") || null;
  }
  return null;
}

export function canAccessPath(role: Role | string | null | undefined, path: string): boolean {
  if (!role) return false;
  const item = routeItemForPath(normalizedPath(path));
  return Boolean(item?.roles.includes(role as Role));
}

export function canonicalPathForRole(role: Role | string | null | undefined, path: string): string {
  const pathname = normalizedPath(path);
  return canAccessPath(role, pathname) ? pathname : "/";
}

export function canViewBusinessDashboard(role: Role | string | null | undefined): boolean {
  return role === "company_user";
}
